import {get} from "lodash"

import postForm from "@irati/utils/PostForm"
import {UnauthedBusiness, Tenant, User} from "@irati/types"
import {SAML_REQUEST_TYPE_POST, SAML_REQUEST_TYPE_REDIRECT} from "../constants/signUpOptions"

import {samlInitiateLogin} from "../services/sso"

interface SSOReturn {
  user: User
  access_token: string
  tenant: Tenant
}

export const initiateSamlLogin = (tenant: UnauthedBusiness | Tenant): Promise<SSOReturn> => {
  const singleSignOnPopUp = window.open("/empty-loader.html", "singleSignOnWindow", "width=400, height=600")

  return new Promise((resolve, reject) => {
    if (!singleSignOnPopUp) {
      return reject("Popup failed to load")
    }

    const handleSuccess = (details: {data: SSOReturn}) => {
      const userId = get(details, "data.user.uuid")
      const access_token = get(details, "data.access_token")
      const userTenant = get(details, "data.tenant")
      if (userId && access_token && userTenant) {
        singleSignOnPopUp.close()
        resolve(details.data)
        window.removeEventListener("message", handleSuccess)
      }
    }

    samlInitiateLogin(tenant).then((data) => {
      if (!data.SAMLRequestName || !data.SAMLRequestValue) {
        singleSignOnPopUp.location = data.SAMLRequestURL
      } else if (data.SAMLRequestType === SAML_REQUEST_TYPE_REDIRECT) {
        const querySymbol = data.SAMLRequestURL.includes("?") ? "&" : "?"
        /* eslint-disable max-len */
        singleSignOnPopUp.location.href = `${data.SAMLRequestURL}${querySymbol}${data.SAMLRequestName}=${data.SAMLRequestValue}`
        /* eslint-enable max-len */
      } else if (data.SAMLRequestType === SAML_REQUEST_TYPE_POST) {
        const form = postForm(data.SAMLRequestURL, {[data.SAMLRequestName]: data.SAMLRequestValue})
        form.target = "singleSignOnWindow"
        form.submit()
      }
      window.addEventListener("message", handleSuccess)
    })
  })
}
